<template>
	<ShareModal v-model:show="visible" :data />
</template>

<script setup lang="ts">
import ShareModal from "@/components/exams/Reports/ShareModal.vue"
import { useShareExamReport } from "@/composables/exam-report/useShareExamReport"

const { visible, data } = useShareExamReport()
</script>
